export default {
  Buttons: {
    connectWallet: 'Connect Wallet',
    boost: 'Boost'
  },
  MenuBar: {
    earn: 'Earn',
    ship: 'Ship',
    journey: 'Journey',
    leaders: 'Referals',
    nft: 'NFT',
    swaps: 'Swaps'
  },
  EarnView: {
    profitPerHours: 'Profit per hours:',
    dailyReward: 'Daily Reward',
    yourCoin: 'Your Coin'
  }
}
